export const routeConfig = {
  meta: {
    title: '账单详情',
  },
  params: ':orderNo'
};
